<script setup lang="ts">
import { computed } from 'vue';
import { clinicalVoidLine, type ClinicalVoidDetails } from '@/utils/clinical-void';

// "Anulado" and who anuló a registro clínico, when and why, next to it; nothing
// for a registro in force.
const props = withDefaults(defineProps<{
  voided?: boolean;
  details?: ClinicalVoidDetails | null;
}>(), { voided: false, details: null });

const line = computed(() => clinicalVoidLine(props.details));
</script>
<template>
  <div
    v-if="props.voided"
    class="d-flex flex-wrap align-center ga-1"
  >
    <v-chip
      size="x-small"
      variant="tonal"
      color="error"
      label
    >
      Anulado
    </v-chip>
    <span
      v-if="line"
      class="text-caption text-medium-emphasis"
    >
      {{ line }}
    </span>
  </div>
</template>
